import { ExperiencePerformanceTypes } from './platform-client/core/experience/experience-types';
export let UFOGlobalEventStreamEventType;

(function (UFOGlobalEventStreamEventType) {
  UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
  UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
  UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
})(UFOGlobalEventStreamEventType || (UFOGlobalEventStreamEventType = {}));

export let PageVisibleState;

(function (PageVisibleState) {
  PageVisibleState["VISIBLE"] = "visible";
  PageVisibleState["HIDDEN"] = "hidden";
  PageVisibleState["MIXED"] = "mixed";
})(PageVisibleState || (PageVisibleState = {}));

export let PageLoadMetrics;

(function (PageLoadMetrics) {
  PageLoadMetrics["fmp"] = "fmp";
  PageLoadMetrics["tti"] = "tti";
})(PageLoadMetrics || (PageLoadMetrics = {}));

export let PageSegmentLoadMetrics;

(function (PageSegmentLoadMetrics) {
  PageSegmentLoadMetrics["fmp"] = "fmp";
  PageSegmentLoadMetrics["tti"] = "tti";
})(PageSegmentLoadMetrics || (PageSegmentLoadMetrics = {}));

export let InteractionMetrics;

(function (InteractionMetrics) {
  InteractionMetrics["response"] = "response";
  InteractionMetrics["result"] = "result";
})(InteractionMetrics || (InteractionMetrics = {}));

export let CustomMetrics;

(function (CustomMetrics) {
  CustomMetrics["duration"] = "duration";
})(CustomMetrics || (CustomMetrics = {}));

export const SUBSCRIBE_ALL = '__SUBSCRIBE_ALL__';
export const FMP_MARK = 'fmp';
export const INLINE_RESPONSE_MARK = 'inline-response';